import { useLocation } from "react-router-dom";

const InputBar = () => {
  const location = useLocation();
  const isEmailInbox = location.pathname === "/email-inbox";

  return (
    <div className="sticky bottom-0 rounded-[12px] z-10 w-full pt-2 bg-white">
      <div className="w-full h-[38px] pb-2 rounded-[7.6px] flex items-center px-1">
        <div className="w-full py-1 pr-1 flex flex-row items-center justify-between bg-[#E5E6E7] rounded-[7.6px]">
          <input
            type="text"
            placeholder="Write your message....."
            className="w-full text-[11px] font-inter bg-[#E5E6E7] font-normal leading-[100%] tracking-[0%] text-[#00000096] text-opacity-60 px-2 py-2 rounded-[5px] outline-none border-none"
          />

          <div className="flex flex-row items-center justify-end w-1/2 gap-x-3">
            <img
              src="/icons/attach.png"
              alt="Attach"
              className="w-[18px] h-[18px] rounded-full object-cover cursor-pointer"
            />
            {!isEmailInbox && (
              <img
                src="/icons/grey-call.png"
                alt="Call"
                className="w-[18px] h-[18px] rounded-full object-cover cursor-pointer"
              />
            )}
            <button className="px-3 w-auto h-6 text-opacity-90 text-white text-[9px] font-inter font-normal leading-[100%] tracking-[0%] bg-black rounded-[8px] flex items-center justify-center">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputBar;
